// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation-module__navigation__M1EEJ","menu":"Navigation-module__menu__LLOSm"};